export enum TrackingEvents {
    AI_SUMMARY_INTERACTIONS = 'ai_profile_summary_interactions',
    AI_SUMMARY_FEEDBACK_CLICKED = 'ai_profile_summary_feedback_clicked',
    AI_SUMMARY_FEEDBACK_SUBMITTED = 'ai_profile_summary_feedback_submitted',
    AI_SUMMARY_VIEWED = 'ai_profile_summary_viewed',
    RECOMMENDATION_REQUEST_SENT = 'recommendation_request_sent',
    PROFILE_EDITION_OPENED = 'profile_edition_opened',
    // AS-2160: this event is temporary, to check this internal feature usage
    TEMPORARY_PROFILE_TO_PDF = 'temp_profile_to_pdf',
    RESUME_IMPORT_FUNNEL = 'profile_import_funnel_step_viewed',
    TRANSLATION = 'freelancer_profile_translated',
    FAQ_OPENED = 'faq_opened',
    PROFILE_PORTFOLIO_SECTION_CLICKED = 'profile_portfolio_section_clicked',
    PROFILE_SECTION_REACHED = 'profile_section_reached',
    PROFILE_UPDATE_CARD_VIEWED = 'profile_update_card_viewed',
    PROFILE_SOCIAL_SHARE_OPENED = 'profile_social_share_opened',
    PROFILE_SOCIAL_SHARE_STARTED = 'profile_social_share_started',
    PROFILE_SOCIAL_SHARE_IMAGE_DOWNLOADED = 'profile_social_share_image_downloaded',
    PROFILE_UPDATED = 'profile_updated',
    PROFILE_VIEWED = 'profile_viewed',
    INFLUENCE_LINK_CLICKED = 'influence_link_clicked',
    RECOMMENDATION_REQUEST_STARTED = 'recommendation_request_started',
    RECOMMENDATION_LEFT = 'recommendation_left',
    RECOMMENDATION_DELETED = 'recommendation_deleted',
    RECOMMENDATION_EMAIL_LINK_OPENED = 'recommendation_email_link_opened',
    SUGGESTED_FOR_YOU_VIEWED = 'suggested_for_you_viewed',
    SUGGESTED_FOR_YOU_CARD_VIEWED = 'suggested_for_you_card_viewed',
    SUGGESTED_FOR_YOU_CARD_CTA_CLICKED = 'suggested_for_you_card_cta_clicked',
}

export enum ProfileViewMode {
    EDITION = 'edition',
    READ_ONLY = 'read_only',
}

export enum ProfileViewedOrigin {
    FREELANCER_AS_CLIENT = 'freelancer_as_client',
    PROFILE_RECOMMENDATION_LIST = 'profile_recommendation_list',
    SIMILAR_PROFILE = 'similar_profile',
    DASHBOARD_UPDATE_PROFILE = 'dashboard_update_profile',
    DASHBOARD_PROFILE_NAME = 'dashboard_profile_name',
    SITE_NAV_BAR = 'site_nav_bar',
    DIRECT_URL = 'direct_url',
}

export type TemporaryProfileToPdfEventPayload = {
    profile_to_pdf_anynomization: boolean;
    profile_to_pdf_dailyrate_edition: boolean;
    profile_to_pdf_dailyrate_display: boolean;
    profile_to_pdf_skillset_display: boolean;
    profile_to_pdf_industryexpertise_display: boolean;
    profile_to_pdf_title_display: boolean;
};

export enum AISummaryContext {
    AI_SEARCH = 'ai_search',
    ATS = 'ats',
    RECO = 'reco',
    SEARCH = 'search',
    SEO = 'seo',
}

export enum AISummaryFeedbackType {
    THUMB_UP = 'thumb_up',
    THUMB_DOWN = 'thumb_down',
}

export enum AISummaryProfileType {
    PROFILE_PAGE = 'profile_page',
    PROFILE_DRAWER = 'profile_drawer',
}

export enum AISummaryStateAction {
    SECTION_COLLAPSED = 'collapsed',
    SECTION_EXPANDED = 'expanded',
}

export enum EditionOpenedEntryPoint {
    PROFILE_ALERT = 'profile_alert',
    PROFILE_PAGE = 'profile_page',
    PROFILE_GAUGE = 'profile_gauge',
    PROFILE_TASK_CARD = 'profile_task_card',
    PROFILE_TASK_LIST_ITEM = 'profile_task_list_item',
    PROFILE_SUGGESTED_FOR_YOU_CARD = 'profile_suggested_for_you_card',
    PROFILE_POPUP = 'profile_popup',
    MESSENGER = 'messenger',
    EXPERIENCE_UPDATE_CARD = 'experience_update_card',
    PROJECT_FUNNEL = 'project_funnel',
    LINKEDIN_IMPORT_CTA = 'linkedin_import_cta',
}

export enum EditionOpenedSection {
    PORTFOLIO = 'portfolio',
    PHOTO = 'photo',
    HEADER = 'header',
    SKILL_SET = 'skill_set',
    LANGUAGES = 'languages',
    DESCRIPTION = 'description',
    LOCATION = 'location',
    INDUSTRY_EXPERTISE = 'industry_expertises',
    CERTIFICATION = 'certification',
    EDUCATIONS = 'educations',
    EXPERIENCES = 'experiences',
    EXPERIENCE_LEVEL = 'experience_level',
    HEADLINE = 'headline',
    CATEGORIES = 'categories',
    INFLUENCE = 'influence',
    DAILY_RATE = 'daily_rate',
    PROJECT_DURATION_PREFERENCES = 'project_duration_preferences',
    PROJECT_COMPANY_SIZE_PREFERENCES = 'project_company_size_preferences',
    PROJECT_ACTIVITY_AREA_PREFERENCES = 'project_activity_area_preferences',
}

export enum EditionOpenedWorkflow {
    MANUAL = 'manual',
    UPLOAD = 'upload',
}

export enum EditionOpenedLabel {
    INVALID = 'Invalid',
    CAN_BE_ENHANCED = 'Can be enhanced',
    MANDATORY_INFORMATION_MISSING = 'Mandatory information missing',
    WELL_DONE = 'Well done',
}

export enum ResumeImportStep {
    UPLOAD_RESUME = 'upload',
    DUPLICATED_EXPERIENCES = 'duplicate',
    EXPERIENCE_LIST = 'all_experiences',
    IMPORT_DONE = 'profile_page_import_done',
}

export enum TranslationAction {
    TRANSLATE = 'translate',
    REVERSE = 'reverse',
}

export type SocialShareEntryPoint = 'linkedin' | 'facebook' | 'email' | 'direct_link';

export enum ProfileUpdatedSection {
    PHOTO = 'photo',
}

export enum ProfileUpdatedElementStatus {
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    DELETED = 'DELETED',
}
export enum ProfileSectionReachedEntryPoint {
    PROFILE_NAVIGATION_BAR = 'profile_navigation_bar',
    HEADER_STARS = 'header_stars',
    HEADER_THUMB_UP = 'header_thumb_up',
}

export enum ProfileSectionReachedSection {
    ABOUT = 'about',
    EXPERIENCE = 'experience',
    EDUCATION = 'education',
    PORTFOLIO = 'portfolio',
    REVIEWS = 'review',
    RECOMMENDATIONS = 'recommendation',
}

export enum ProfileSectionReachedContext {
    PROFILE_PAGE = 'profile_page',
    PROFILE_DRAWER = 'profile_drawer',
}

export enum InfluenceLinkType {
    BEHANCE = 'behance',
    GITHUB = 'github',
    STACKOVERFLOW = 'stackoverflow',
    KAGGLE = 'kaggle',
}

export enum RecommendationRequestStartedEntryPoint {
    HEADER_CTA = 'header_cta',
    TASK_CARD = 'task_card',
    SECTION_EDIT = 'section_edit',
    ALERT_SECTION = 'alert_section',
    PROFILE_SUGGESTED_FOR_YOU_CARD = 'profile_suggested_for_you_card',
}

export enum RecommendationDeletedBy {
    FREELANCER = 'freelancer',
    AUTHOR = 'author',
}

export enum RecommendationEmailLinkOpenedRecommenderStatus {
    NEW_ACCOUNT_CREATED = 'new_account_created',
    LOGGED_IN = 'logged_in',
}
